namespace Seac.Pages {
	jQuery(document).ready(() => {
		// Sottoscrivo l'evento mouseEnter degli elementi label
		// Nel caso in cui il testo sia troppo lungo (viene troncato dal CSS) imposto il title
		// in modo che al passaggio del mouse si veda il testo intero
		$(document).delegate('label', Seac.Commons.Constants.mouseEnterEvent, (event: JQuery.MouseEnterEvent) => {
			if (event.target.offsetWidth < event.target.scrollWidth && !event.target.hasAttribute('title')) {
				event.target.setAttribute('title', event.target.innerText);
			}
		});

		if (!Seac.Pages.PageUtility.isMobileDevice) {
			// Attivo i tooltip solo se NON sono su mobile

			// Sottoscrivo l'evento mouseEnter degli elementi che hanno un tooltip definito
			// Attivo e visualizzo il tooltip quando il mouse entra nell'area
			$(document).delegate('[data-toggle="tooltip"]', Seac.Commons.Constants.mouseEnterEvent, (event) => {
				$(event.currentTarget).tooltip(Seac.Commons.Constants.Bootstrap.tooltipShow);
			});

			// Alla creazione di un toolpit rimuovo quelli precedenti
			$(document).delegate('[data-toggle="tooltip"]', Seac.Commons.Constants.Bootstrap.tooltipShownEvent, (event) => {
				const cuttentTooltipId = $(event.target).attr('aria-describedby');
				$('.tooltip.show').not(`#${cuttentTooltipId}`).remove();
			});
		}

		const localStorageVersion : string = localStorage.getItem('appVersion');
		const currentAppVersion: string = $('.app-version').data('app-version'); 

		if (!localStorageVersion || (currentAppVersion != localStorageVersion)) {
			// Se non è salvata una versione dell'applicazione, oppure se la versione è diversa allora eseguo delle operazioni

			// Elimino i filtri salvati per le griglie
			const localStorageKeys : Array<string> = Object.keys(localStorage);
			localStorageKeys.forEach((key: string) => {
				if (key.indexOf(Seac.Services.gridFilterPersistenceService.gridFiltersSuffix) === 0) {
					localStorage.removeItem(key);
				}
			});

			localStorage.setItem('appVersion', currentAppVersion);
		}

		// Chiamo subito il metodo che nasconde il menu se la pagina è troppo stretta
		Seac.Pages.PageUtility.hideMenuOnSmallPage();
		// Ad ogni resize della window chiamo il metodo che nasconde il menu se la pagina è troppo stretta
		$(window).resize(() => {
			Seac.Pages.PageUtility.hideMenuOnSmallPage();
		});
	});
}
